import { CustomPageHeader, Text } from '@src/components';
import PaymentList from './PaymentList';
const PendingPayment = () => {
    return (
        <CustomPageHeader
            title={<Text t="youHavePendingPayments" />}
            showBreadCrumb
            showHelpButton
        >
            <PaymentList/>
        </CustomPageHeader>
    )
}

export default PendingPayment;
